import { render } from "./AppPortalLayout.vue?vue&type=template&id=2cfac680"
import script from "./AppPortalLayout.vue?vue&type=script&lang=js"
export * from "./AppPortalLayout.vue?vue&type=script&lang=js"
script.render = render

export default script